<a [popover]="personPopover" id="{{popoverLinkId}}" placement="bottom" href="javascript:void(0)" class="flag-popup"
  (click)="onClick()" triggers="" #pop="bs-popover">
  <ng-content></ng-content>
</a>
<ng-template #personPopover>
  <div id="{{popoverContainerId}}" class="d-flex" style="gap: 12px; max-width: 320px;">
    <img src="{{person?.photo ? (person.photo | stableImg) : 'assets/img/user-profile.png'}}" alt=""
      class="rounded-circle flex-shrink-0" style="width: 52px; height: 52px; object-fit: cover;">
    <div class="flex-grow-1" style="min-width: 0;">
      <div style="font-weight: 600;">{{person | fullNameDegrees}}</div>
      <div *ngIf="person?.title" class="text-muted" style="font-size: 12.5px;">{{person?.title}}</div>
      <div *ngIf="person?.affiliation" class="text-muted" style="font-size: 12.5px;">{{person?.affiliation}}</div>

      <div *ngIf="person?.default_address?.phone" class="d-flex align-items-center" style="gap: 8px; margin-top: 6px; font-size: 13px;">
        <i class="mdi mdi-phone text-muted" style="font-size: 16px; width: 18px; text-align: center; flex: none;" aria-hidden="true"></i>
        <span>{{person?.default_address?.phone}}</span>
      </div>
      <div *ngIf="person?.cell_phone" class="d-flex align-items-center" style="gap: 8px; font-size: 13px;">
        <i class="mdi mdi-cellphone text-muted" style="font-size: 16px; width: 18px; text-align: center; flex: none;" aria-hidden="true"></i>
        <span>{{person?.cell_phone}}</span>
      </div>
      <div *ngIf="person?.email" class="d-flex align-items-center" style="gap: 8px; font-size: 13px;">
        <i class="mdi mdi-email text-muted" style="font-size: 16px; width: 18px; text-align: center; flex: none;" aria-hidden="true"></i>
        <span class="text-break">{{person?.email}}</span>
      </div>
      <div *ngIf="type == 'area_manager' && event?.event_area" class="d-flex align-items-center" style="gap: 8px; font-size: 13px;">
        <i class="mdi mdi-map-marker text-muted" style="font-size: 16px; width: 18px; text-align: center; flex: none;" aria-hidden="true"></i>
        <span>{{event?.event_area | areaFullName}}</span>
      </div>

      <div class="d-flex" style="gap: 8px; margin-top: 10px;">
        <a [routerLink]="getUrl()" bkButton size="sm">Edit</a>
        <a *ngIf="type == 'speaker'" href="javascript:void(0);" (click)="speakerStatus()" bkButton color="secondary" size="sm">Change Status</a>
      </div>
    </div>
  </div>
</ng-template>